import React, { type ReactNode } from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';
import { darkColors } from '../constants/colors';
import { spacing } from '../constants/spacing';
import { useAppColors } from '../context/PreferencesContext';

type Props = { children: ReactNode; style?: StyleProp<ViewStyle> };

export function AppCard({ children, style }: Props) {
  const palette = useAppColors();
  const isDark = palette.background === darkColors.background;
  return (
    <View
      style={[
        styles.card,
        {
          backgroundColor: palette.surface,
          borderColor: palette.border,
          shadowOpacity: isDark ? 0 : 0.06,
          elevation: isDark ? 0 : 2,
        },
        style,
      ]}
    >
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderWidth: 1,
    borderRadius: 16,
    padding: spacing.lg,
    minWidth: 0,
    maxWidth: '100%',
    shadowColor: '#0F172A',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.06,
    shadowRadius: 12,
    elevation: 2,
  },
});
